module.exports = __webpack_public_path__ + "static/img/PU page top img_desktop.02b5ce8f.jpg";